import {useContext} from "react";
import EditQRCodeContext from "./EditQRCodeContext";
import {Button, Center, Stack} from "@mantine/core";
import {useNavigate} from "react-router-dom";

/**
 * Shows fallback text.
 * To use in case we have not implemented form for this kinda QR code.
 * @author Kacper Faber
 * @since 0.2.0
 */
function NoForm() {
    /**
     * EditQRCodeContext
     * @author Kacper Faber
     * @since 0.2.0
     */
    const ctx = useContext(EditQRCodeContext);

    /**
     * Navigate function
     * @author Kacper Faber
     * @since 0.2.0
     */
    const navigate = useNavigate();

    /**
     * Push back to the previous page
     * @author Kacper Faber
     * @since 0.2.0
     */
    const goBack = () => {
        navigate(-1);
    }

    return (
        <Center mt="xl">
            <Stack>
                Aktualnie nie ma możliwości edycji tego kodu o typie '{ctx.qrCode?.kind}'
                <Button variant="transparent" onClick={goBack}>
                    Powrót
                </Button>
            </Stack>
        </Center>
    );
}

export default NoForm;